var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaPanama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_21746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3285 0H6.59101V45H51.3379L51.3285 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7188 0.337402H-3.84375V21.1218H29.7188V0.337402Z",
    fill: "#DB0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7002 21.1218H29.7096V44.9999H59.7002V21.1218ZM39.8627 16.6593L43.8002 13.903L47.7096 16.678L46.2564 12.178L50.1564 9.3749L45.3189 9.3374L43.8189 4.8374L42.2908 9.32803H37.4533L41.3439 12.1405L39.8533 16.6405L39.8627 16.6593Z",
    fill: "#0000AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5406 38.8029L15.5156 36.2061L19.4625 38.8311L18 34.5561L21.9375 31.9311L17.0625 31.8842L15.5437 27.6279L14.0062 31.8748H9.13125L13.05 34.5467L11.55 38.8029H11.5406Z",
    fill: "#D80000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_21746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaPanama);
export default __webpack_public_path__ + "static/media/pa Panama.20c9bf4dae8175bae93362b888898bb8.svg";
export { ForwardRef as ReactComponent };